import useSWR, { SWRConfiguration } from 'swr';
import { FILE_DOWNLOAD_URL } from '@/constant/apiList';
import { DownLoadResponse } from '@/types/api';
import { getNestedDataFetcher } from '@/utils/apis';

/**
 * uuid → 다운로드 URL 매핑 (SWR 캐시).
 * - uuid가 falsy거나 'uploading' placeholder면 호출 skip
 * - private 모드(만료 짧음)인 경우 호출부에서 revalidate / dedupingInterval 등을 config로 조절
 */
const useDownloadUrl = (uuid?: string | null, config?: SWRConfiguration) =>
  useSWR<DownLoadResponse>(
    uuid && uuid !== 'uploading' ? `${FILE_DOWNLOAD_URL}?uuid=${uuid}` : null,
    getNestedDataFetcher,
    config,
  );

export default useDownloadUrl;
